export default __webpack_public_path__ + "static/media/howtouse_plus_05_01_ko.7534cd42.png";